/* eslint-disable */
var Helper = function () {
  this.boundFunctions = [];
};
Helper.prototype = {
  bind: function (event, callback) {
    // check to see if it's already bound and skip
    if (this.boundFunctions.indexOf(callback) > -1) {
      return;
    }
    this.boundFunctions.push(callback);
    window.addEventListener(event, callback);
  },
  trigger: function (event, data) {
    window.dispatchEvent(new CustomEvent(event), [data]);
  },
  mediaTypes: {
    photo: "photo",
    video: "video",
    panorama: "panorama",
  },
};

export const helper = new Helper();
export const bind = helper.bind;
export const trigger = helper.trigger;
export const mediaTypes = helper.mediaTypes;

var yvEvent = "YouVisit.";
export const events = {
  init: yvEvent + "init", //Initialize the mobile walking tour with tour data (inst_id, loc_id)
  load: yvEvent + "load", //When WalkingTour is loaded
  loadComplete: yvEvent + "loadComplete", //When all assets are loaded
  tourStopChanging: yvEvent + "tourStopChanging", //Update the view to reflect the next stop
  tourStopSelected: yvEvent + "tourStopSelected", //Change stops in tour
  stopChanged: yvEvent + "stopChanged", //Change stops in tour
  showMediaPanel: yvEvent + "showMediaPanel", //Show the media panel
  closeMediaPanel: yvEvent + "closeMediaPanel", //Closing the media panel
  onAudioToggled: yvEvent + "onAudioToggled", //whenever the DescriptionAudioController toggles the audio
  toggleAudio: yvEvent + "toggleAudio", //when triggered, DescriptionAudioController should toggle the audio
  audioLoaded: yvEvent + "audioLoaded", //when the DescriptionAudioController loads audio
  onStopAudioUpdate: yvEvent + "onStopAudioUpdate", //when a stop changes and the status of audio availability changes
  updateAudioDesc: yvEvent + "updateAudioDesc", //allows description to be updated at will
  aPanoPlayersViewReady: yvEvent + "aPanoPlayersViewReady", //the source code is too bad and hard to follow to figureout how to bind to the real viewReady event, so I'm hacking it with this global event and making the assumption that we're only loading one pano player at a time, which is mostly safish
  orientationChanged: yvEvent + "orientationChanged", //triggered when going between landscape / portrait. useful for showing VR overlay.
  sessionIdChanged: yvEvent + "sessionIdChanged",
};
